import {GET_HIRE_DECISION_LIST, GET_HIRE_DECISION_LIST_SUCCESS, GET_HIRE_DECISION_LIST_FAILED} from './actionType'

export const getHireDecisionListData = (json)=>{
    return{
        type:GET_HIRE_DECISION_LIST,
        payload: {json}
    }
}

export const getHireDecisionListSuccess = (json)=>{
    return{
        type:GET_HIRE_DECISION_LIST_SUCCESS,
        payload: json
    }
}


export const getHireDecisionListFail = (json)=>{
    return{
        type: GET_HIRE_DECISION_LIST_FAILED,
        payload: json
    }
}

